module.exports = __webpack_public_path__ + "img/Frame 716.92e10a16.png";